<template>
  <app-drawer ref="appDrawer" title="Invoice Information">
    <div class="el-drawer__content" v-loading="isLoading">
      <el-form
        ref="invoiceForm"
        :model="formModel"
        :rules="rules"
        label-position="top"
      >
        <el-alert :closable="false" type="info" class="mb-1">
          <span style="font-size: 16px"
            >Fill-in the form to search for available Job Orders.</span
          >
        </el-alert>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="Start Date" prop="datefrom">
              <el-date-picker v-model="formModel.datefrom"> </el-date-picker>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="End Date" prop="dateto">
              <el-date-picker v-model="formModel.dateto"> </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="Customer/Airline" prop="customer_id">
              <el-select
                @change="getCodes"
                v-model="formModel.customer_id"
                clearable
                filterable
              >
                <el-option
                  v-for="d in customers"
                  :value="d.value"
                  :key="d.value"
                  :label="d.text"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="Customer Owner Codes" prop="customer_codes">
              <el-select v-model="formModel.customer_code" clearable filterable>
                <el-option
                  v-for="d in customer_codes"
                  :value="d.value"
                  :key="d.value"
                  :label="d.text"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="15">
          <el-col :span="12">
            <el-form-item label="Invoice Date" prop="invoice_date">
              <el-date-picker
                v-model="formModel.invoice_date"
                :picker-options="{
                  disabledDate: disabledDates
                }"
              ></el-date-picker>
            </el-form-item>
          </el-col>
          <!-- <el-form-item label="Invoice ID" prop="invoice_id">
                  <el-input v-model="formModel.invoice_id"></el-input>
                </el-form-item> -->
          <!-- <el-form-item label="Customers" prop="owner_code">
                  <el-select
                    v-model="formModel.owner_code"
                    clearable
                    filterable
                  >
                    <el-option
                      v-for="(code, index) in ownerCodes"
                      :key="index"
                      :value="code"
                      :label="code"
                    ></el-option>
                  </el-select>
                </el-form-item> -->
        </el-row>

        <el-row>
          <el-col>
            <el-table
              ref="invoiceTable"
              :data="data.data"
              @selection-change="updateSelection"
              max-height="500"
            >
              <el-table-column type="selection" width="55"> </el-table-column>
              <el-table-column
                fixed
                width="120"
                label="Job Order No."
                prop="job_order_number"
              >
              </el-table-column>

              <el-table-column
                min-width="140"
                label="ULD ID Code"
                prop="masterlist.uld_id_code"
              >
              </el-table-column>
              <el-table-column
                width="120"
                label="ULD Part No."
                prop="masterlist.part"
              >
              </el-table-column>
              <el-table-column
                width="120"
                label="Manufacturer"
                prop="masterlist.manufacturer"
              >
              </el-table-column>

              <el-table-column
                width="200"
                label="Description"
                prop="masterlist.description"
              >
              </el-table-column>
              <el-table-column width="120" label="Owner" prop="customer_name">
                <!-- <template slot-scope="scope">
                  {{ getCustomer(scope.row.masterlist.owner) }}
                </template> -->
              </el-table-column>
              <el-table-column
                width="120"
                label="Repaired Date"
                prop="job_completed"
              >
                <template slot-scope="scope">
                  {{ scope.row.job_completed | dateFormat("M/D/YYYY") }}
                </template>
              </el-table-column>
              <el-table-column
                width="120"
                label="Date Received"
                prop="date_received"
              >
                <template slot-scope="scope">
                  {{ scope.row.date_received | dateFormat("M/D/YYYY") }}
                </template>
              </el-table-column>
              <el-table-column
                width="120"
                label="Collected From"
                prop="collected_from"
              >
              </el-table-column>
              <el-table-column width="100" label="Delivery Date" prop="">
                <template slot-scope="scope">
                  {{
                    scope.row.uld_out
                      ? scope.row.uld_out.delivery_date
                      : "" | dateFormat
                  }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="Delivery No." prop="">
                <template slot-scope="scope">
                  {{ scope.row.uld_out ? scope.row.uld_out.delivery_num : "" }}
                </template>
              </el-table-column>
              <el-table-column width="100" label="Labor" prop="labor">
              </el-table-column>
              <el-table-column width="100" label="Materials" prop="materials">
              </el-table-column>
              <el-table-column
                width="100"
                label="Cleaning"
                prop="cleaning_cost"
              >
              </el-table-column>
              <el-table-column width="120" label="Remarks" prop="remarks">
              </el-table-column>
            </el-table>
          </el-col>
        </el-row>
      </el-form>
      <div class="el-drawer__footer">
        <el-button
          @click="save"
          type="primary"
          :disabled="invoiceSelection.length == 0"
        >
          Create Invoice
        </el-button>
        <el-button @click.prevent="close()">Cancel</el-button>
      </div>
    </div>
  </app-drawer>
</template>

<script>
import ULD from "@/models/ULD";
import moment from "moment";
export default {
  name: "ULD_Invoice",
  // props: ["invoiceSelection", "customer_id"],
  data: () => ({
    isLoading: false,
    formModel: {
      invoice_date: "",
      invoice_id: "",
      owner_code: "",
      customer_id: null,
      customer_code: null,
      datefrom: "",
      dateto: ""
    },
    rules: {
      invoice_date: [{ required: true, message: "Invoice date is required." }],
      // invoice_id: [{ required: true, message: "Invoice id is required." }],
      customer_id: [{ required: true, message: "Customer is required." }],
      datefrom: [{ required: true, message: "Start Date is required." }],
      dateto: [{ required: true, message: "End Date is required." }]
    },
    data: { data: [] },
    customers: [],
    customer_codes: [],
    ownerCodes: [
      "EY",
      "AA",
      "WY",
      "MT",
      "US",
      "9W",
      "AZ",
      "EB",
      "AB",
      "HM",
      "LH",
      "JE",
      "JG",
      "FK",
      "LX",
      "EY-Eng",
      "EJ",
      "CV",
      "QR",
      "5Y",
      "C6",
      "Etihad"
    ],
    invoiceSelection: [],
    lastInvoiceDate: null
  }),
  computed: {
    customer() {
      return this.customer_id
        ? this.customers.find(o => o.value == this.customer_id)
        : {};
    }
  },
  watch: {
    "formModel.datefrom": function() {
      this.getReport();
    },
    "formModel.dateto": function() {
      this.getReport();
    },
    "formModel.customer_id": function() {
      this.getReport();
    },
    "formModel.customer_code": function() {
      this.getReport();
    }
  },
  methods: {
    disabledDates(date) {
      if (!this.lastInvoiceDate) return false;

      let last_invoice_date = moment(this.lastInvoiceDate);
      let _date = moment(date);
      if (_date.isBefore(last_invoice_date)) {
        return true;
      } else {
        return false;
      }
    },
    open() {
      this.$refs.appDrawer.open();
    },
    close() {
      this.$refs.appDrawer.close();
      this.$emit("refreshList");
    },
    updateSelection(selection) {
      this.invoiceSelection = selection;
    },
    getReport() {
      if (
        !this.formModel.datefrom ||
        !this.formModel.dateto ||
        !this.formModel.customer_id // || !this.formModel.customer_code
      ) {
        this.data = {};
        return;
      }

      this.isLoading = true;
      let params = {
        datefrom: moment(this.formModel.datefrom).format("YYYY-MM-DD"),
        dateto: moment(this.formModel.dateto).format("YYYY-MM-DD"),
        customer_id: this.formModel.customer_id,
        customer_code: this.formModel.customer_code
          ? this.formModel.customer_code
          : 0,
        is_invoice_view: 1,
        limit: 2000
      };
      ULD.list(params).then(resp => {
        this.isLoading = false;
        this.data = resp;
        this.$refs.invoiceTable.toggleAllSelection();
        this.lastInvoiceDate = resp.last_invoice_date;
      });
    },
    getCustomer(customer) {
      let c = this.customers.find(o => o.value == customer);
      if (c) return c.text;
      else "";
    },
    save() {
      if (this.invoiceSelection.length == 0) return;
      this.$confirm("Do you want to create invoices based on the form details?")
        .then(() => {
          this.$refs.invoiceForm.validate(valid => {
            if (!valid) return false;
            let payload = {
              invoice_date: moment(this.formModel.invoice_date).format(
                "YYYY-MM-DD"
              ),
              uldin_id: this.invoiceSelection.map(o => o.id).toString(),
              // invoice_id: this.formModel.invoice_id,
              // owner_code: this.formModel.owner_code
              customer_id: this.formModel.customer_id
            };

            this.isLoading = true;
            ULD.post_invoice(payload).then(resp => {
              if (resp.data.code == 200) {
                this.$notify({
                  type: "success",
                  position: "bottom-right",
                  message: "Invoice created."
                });
                this.formModel = {
                  invoice_date: "",
                  // invoice_id: "",
                  // owner_code: ""
                  customer_id: null,
                  datefrom: "",
                  dateto: "",
                  customer_code: null
                };
                this.$nextTick(() => {
                  this.$refs.invoiceForm.clearValidate();
                });
                this.close();
                this.isLoading = false;
              } else {
                this.$notify({
                  type: "error",
                  position: "bottom-right",
                  message: resp.data.message
                });
              }
            });
          });
        })
        .catch(() => {});
    },
    customer_list() {
      ULD.customers_data().then(resp => {
        this.customers = resp;
      });
    },
    getCodes() {
      this.customer_codes = [];
      this.formModel.customer_code = null;
      let codes = this.customers.find(
        o => o.value == this.formModel.customer_id
      );
      if (codes) {
        for (const key in codes.codes) {
          this.customer_codes.push({
            value: codes.codes[key].code,
            text: codes.codes[key].code
          });
        }
      } else {
        this.customer_codes = [];
      }
    }
  },
  mounted() {
    this.customer_list();
  }
};
</script>

<style lang="scss" scoped></style>
